import angular from 'angular';
import insurerPremiumComparison from './insurerPremiumComparison';
import './style.scss';

export default angular
  .module('components.insurerPremiumComparison', [])
  .component('insurerPremiumComparison', insurerPremiumComparison).name;
